/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseSignupSurvey } from '../../models/api-response-signup-survey';
import { SignupSurvey } from '../../models/signup-survey';

export interface SaveSignupSurvey$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  'X-Forwarded-For'?: string;
      body: SignupSurvey
}

export function saveSignupSurvey(http: HttpClient, rootUrl: string, params: SaveSignupSurvey$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseSignupSurvey>> {
  const rb = new RequestBuilder(rootUrl, saveSignupSurvey.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.header('X-Forwarded-For', params['X-Forwarded-For'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseSignupSurvey>;
    })
  );
}

saveSignupSurvey.PATH = '/v1/api/ui/company/signup-survey';
